module.exports = __webpack_public_path__ + "img/ark-of-the-covenant.f852657f.jpg";